<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/8fZOy6/tc-custom/9781685504540.jpg?1723405968231" alt="This image is the cover for the book Dark's Destiny"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Dark's Destiny
      </h1>
      <p class="bookDescription body article font2">
        <p>Steeped in magical talent but cursed by a prophecy, Dark Arthur would much rather fix up old houses than enter the melee between good and evil in the realm of wizardry. Too bad Fate had other ideas when he steps into the small town bookstore to collect an ancient spell book. He finds a woman who not only possesses remarkable gifts, but also brightens his life with her presence. Protecting her from evil wizards would be difficult enough, but an easy task compared to guarding his heart.<br/><br/>Destiny Jones’s life has been a roller coaster of late, after taking over her late, great aunt’s bookstore. A mystical customer shows up to collect a previously purchased book and Destiny knows he’s trouble. The extent of her magical experience includes rumors of low-wattage witches in the family, unless one cares to include her ability to hold two-sided conversations with her cat. Now, she finds herself reading runes in ancient spells and facing dark wizards in her spare time.<br/><br/>Dark and Destiny must join forces to overcome the evil sent their way. As the danger increases, so do their feelings for each other. But, in the end, will it be enough?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Cheyenne Meadows
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1802aece